import React from 'react';
import { MapPinIcon, PhoneIcon, NavigationIcon } from 'lucide-react';
export function LocationSection() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#ffffff'
  }} aria-label="Location and Directions" data-id="element-1835">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-1836">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start" data-id="element-1837">
          <div className="flex-1" data-id="element-1838">
            <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1839">
              Find Us
            </p>
            <h2 className="text-3xl md:text-4xl font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1840">
              Location &amp; Directions
            </h2>
            <div className="section-divider" data-id="element-1841" />

            <div className="space-y-5 mb-8" data-id="element-1842">
              <div className="flex items-start gap-4" data-id="element-1843">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#f0f7f3'
              }} data-id="element-1844">
                  <MapPinIcon size={18} style={{
                  color: '#1e3d2f'
                }} data-id="element-1845" />
                </div>
                <div data-id="element-1846">
                  <p className="text-sm font-bold uppercase mb-1" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#1e3d2f'
                }} data-id="element-1847">
                    Fenton Lakes Sportsman's Club
                  </p>
                  <p className="text-base" style={{
                  color: '#3a3a3a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-1848">
                    1140 Butcher Rd
                    <br data-id="element-1849" />
                    Fenton, MI 48430-1232
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-1850">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#f0f7f3'
              }} data-id="element-1851">
                  <PhoneIcon size={18} style={{
                  color: '#1e3d2f'
                }} data-id="element-1852" />
                </div>
                <div data-id="element-1853">
                  <p className="text-sm font-bold uppercase mb-1" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#1e3d2f'
                }} data-id="element-1854">
                    Phone
                  </p>
                  <a href="tel:8106297964" className="text-base transition-colors hover:opacity-80" style={{
                  color: '#2d5a3d',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-1855">
                    (810) 629-7964
                  </a>
                </div>
              </div>
            </div>

            <a href="https://www.google.com/maps/place/Fenton+Lakes+Sportsmans+Club/@42.8417739,-83.6964788,17z/data=!3m1!4b1!4m5!3m4!1s0x882364b491bd2837:0xd11b08e813df5c17!8m2!3d42.8417732!4d-83.6941837?hl=en-US" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3.5 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
            backgroundColor: '#1e3d2f',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1856">
              <NavigationIcon size={16} data-id="element-1857" />
              Get Driving Directions
            </a>
          </div>

          <div className="w-full lg:w-3/5 flex-shrink-0" data-id="element-1858">
            <div className="rounded-2xl overflow-hidden" style={{
            border: '1px solid #ede9e0',
            boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
          }} data-id="element-1859">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Redesign/map.png" alt="Map showing location of Fenton Lakes Sportsman's Club at 1140 Butcher Rd, Fenton, MI" className="block w-full h-auto object-cover" style={{
              maxHeight: '340px',
              objectFit: 'cover'
            }} data-id="element-1860" />
              <div className="px-5 py-3 flex items-center justify-between" style={{
              backgroundColor: '#f8f6f0',
              borderTop: '1px solid #ede9e0'
            }} data-id="element-1861">
                <p className="text-sm" style={{
                color: '#5a5a5a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1862">
                  Just north of Fenton, Michigan
                </p>
                <a href="https://www.google.com/maps/place/Fenton+Lakes+Sportsmans+Club/@42.8417739,-83.6964788,17z/data=!3m1!4b1!4m5!3m4!1s0x882364b491bd2837:0xd11b08e813df5c17!8m2!3d42.8417732!4d-83.6941837?hl=en-US" target="_blank" rel="noopener noreferrer" className="text-xs font-semibold transition-colors hover:opacity-80" style={{
                color: '#2d5a3d',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1863">
                  Open in Google Maps →
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}